import { isValidEmail } from "../../utils/tickets";

/**
 * "Send the response of the case to another person". Only the CTX Reflector
 * desk reads these fields; Kontrol Edge tickets never carry them.
 */
export interface ContactDetails {
  sendResponse: boolean;
  name: string;
  email: string;
  countryCode: string;
  phone: string;
}

export function createEmptyContact(countryCode = "+1"): ContactDetails {
  return { sendResponse: false, name: "", email: "", countryCode, phone: "" };
}

export interface ContactErrors {
  name: string | null;
  email: string | null;
}

/**
 * The rules the contact must meet when the switch is on. An empty field has
 * no message yet, so the form does not open in red; it still fails
 * `isContactValid`, which is what gates Create.
 */
export function getContactErrors(contact: ContactDetails): ContactErrors {
  if (!contact.sendResponse) return { name: null, email: null };
  const name = contact.name.trim();
  const email = contact.email.trim();
  return {
    name:
      name && name.length < 3 ? "Write at least 3 characters." : null,
    email:
      email && !isValidEmail(email)
        ? "Use a valid email, like name@domain.com."
        : null,
  };
}

export function isContactValid(contact: ContactDetails): boolean {
  if (!contact.sendResponse) return true;
  return (
    contact.name.trim().length >= 3 && isValidEmail(contact.email.trim())
  );
}

/** The fields the legacy `/support/CreatedTicket` endpoint expects. */
export function toContactPayload(contact: ContactDetails) {
  return {
    Nombre_de_contacto: contact.name,
    Correo: contact.email,
    phone_number: `${contact.countryCode}${contact.phone.replace(/\s+/g, "")}`,
  };
}
